export default __webpack_public_path__ + "static/media/comedora-menu-logo-transparent.c9e46fd2.png";